import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";

const MatricsDataType = [
  {
    type: "volume",
    typeDisplayName: "Volume",
  },
  {
    type: "resolution_rate",
    typeDisplayName: "Resolution Rate",
  },
  {
    type: "avg_sentiment",
    typeDisplayName: "Avg. Customer Sentiment",
  },
];

const AnimatedValue = ({ value }: any) => {
  const [displayValue, setDisplayValue] = useState(value);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    setDisplayValue(value);

    const timer = setTimeout(() => {
      setAnimate(false);
    }, 500); // Match this with your animation duration

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <span
      className={`matrics-data-slot-counter-value ${animate ? "animate" : ""}`}
      style={{
        fontWeight: "bold",
        fontSize: "2rem",
        transition: "transform 0.5s ease, opacity 0.5s ease",
        display: "inline-block",
        transform: animate ? "scale(1.2)" : "scale(1)",
        opacity: animate ? 0.8 : 1,
      }}
    >
      {displayValue}
    </span>
  );
};

const MatricsDatatoDisplay = ({
  keyMetricsData,
  type,
  typeDisplayName,
}: any) => {
  const value = keyMetricsData
    ? keyMetricsData[type] === null
      ? 0
      : parseFloat(keyMetricsData[type]).toFixed(
          type === "avg_sentiment" ? 1 : 0
        )
    : 0;

  return (
    <div className='complaints-metrics-data-wrapper'>
      <div className='complaints-metrics-group-box dissatisfied-metric grid-right'>
        <div
          style={{ alignItems: "center", marginTop: "10px" }}
          className='comp-no-radio-label complaints-metric comp-right-slot'
        >
          <span className='title'>{typeDisplayName}</span>
        </div>
        <div className='exec-radio-values compliance-metrics-values complaints-met-val complaints-right-metrics'>
          <div className='compliance-sidebar-number'>
            <AnimatedValue value={value} />
            {type === "resolution_rate" && (
              <span className='percentage-sign'>%</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const KeyMetricsTable = ({ keyMetricsData }: any) => {
  return (
    <Grid className='grid-gap' item>
      <div className='complaints-metrics-container'>
        {MatricsDataType.map((item) => (
          <MatricsDatatoDisplay
            keyMetricsData={keyMetricsData}
            type={item?.type}
            typeDisplayName={item?.typeDisplayName}
          />
        ))}
      </div>
    </Grid>
  );
};

export default KeyMetricsTable;
